import BaseApi from '../base/apiBase.service';

export default class CourseResourceService extends BaseApi {
  constructor(args) {
    super(args);

    this.serviceEndpoints = {
      baseUrl: process.env.REACT_APP_BACKEND_URL,
      get: '/api/courseresource',
      create: '/api/courseresource/',
      update: '/api/courseresource/',
    };
  }

  async getByParameters(data) {
    return super.getByParameters(data);
  }

  async get(data) {
    return super.get(data, '/api/courseresource/');
  }

  async create(data) {
    return super.create(data);
  }

  async update(data) {
    return super.update(data);
  }

  async uploadFile(data) {
    data.append('folder', 'course');
    return super.post(data, '/api/upload/file');
  }
}
